// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__9OZrP","tableWrapper":"styles_tableWrapper__KtNlO","table":"styles_table__3VaEy","pagination":"styles_pagination__YVJhS"};